import { registerSW } from "virtual:pwa-register";

async function manageServiceworker() {
    const swReady = await checkIfServiceWorkerAvailable();
    if (!swReady) {
        console.debug('sw-app: Service workers are not supported in this browser.');
        return;
    }
    // Listen for messages from the service worker
    navigator.serviceWorker.addEventListener("message", (event) => {
        console.debug("sw-app: Received a message from service worker:", JSON.stringify(event.data));
        // const data = event.data;
        // // Handle commands from the service worker
        // if (data.command === 'start-worker-ticks') {
        // } else if (data.command === 'stop-worker-ticks') {
        // }
    });
}

/**
 * Checks if the Service Worker API is available and if a service worker is ready.
 *
 * @returns {Promise<boolean>} A promise that resolves to `true` if the Service Worker API is supported
 * and a service worker is successfully registered and ready. Resolves to `false` otherwise.
 *
 */
export async function checkIfServiceWorkerAvailable(): Promise<boolean> {
    if ('serviceWorker' in navigator) {
        try {
            const registration = await navigator.serviceWorker.ready;
            return !!registration; // Returns true if registration exists (not null/undefined)
        } catch (error) {
            console.error('sw-app: Error checking service worker registration:', error);
            return false;
        }
    } else {
        return false;
    }
}

/**
 * Manages the service worker for the application.
 * 
 */
export async function registerServiceWorker() {
    console.debug('sw-app: Registering service worker');
    registerSW({ immediate: true }); // force reload if new update found
    manageServiceworker();
}